<template>
  <div id="contact" class="contact-section">
    <div class="contact-section-header">
      <h2>Let's collaborate...</h2>
      <p>How do you take your coffee ☕?</p>
    </div>
    <div class="contact-links">
      <a
        href="https://twitter.com/msabry809"
        target="_blank"
        class="btn contact-details"
      >
        <i class="fa-brands fa-x-twitter" style="color: #1da1f2;"></i>
        X twitter
      </a>
      <a
        href="https://linkedin.com/in/chemsabry"
        target="_blank"
        class="btn contact-details"
        title="LinkedIn"
      >
        <i class="fab fa-linkedin" style="color: #0B66C2;"></i> LinkedIn
      </a>
      <a
        href="https://stackoverflow.com/users/10529914/mohamed-sabry?tab=profile"
        target="_blank"
        class="btn contact-details"
        title="Stack Overflow"
      >
        <i class="fab fa-stack-overflow" style="color: #fc6d26;"></i> Stack
        Overflow
      </a>
      <a
        href="https://github.com/mosabry"
        target="_blank"
        class="btn contact-details"
      >
        <i class="fab fa-github" style="color: #333;"></i> GitHub
      </a>
      <a
        href="https://gitlab.com/mosabry"
        target="_blank"
        class="btn contact-details"
      >
        <i class="fab fa-gitlab" style="color: #fc6d26;"></i> GitLab
      </a>
      <a
        href="https://bitbucket.org/mosabry/"
        target="_blank"
        class="btn contact-details"
        title="Bitbucket"
      >
        <i class="fab fa-bitbucket" style="color: #2982FA"></i> Bitbucket
      </a>
      <a
        href="https://codepen.io/mosabry/"
        target="_blank"
        class="btn contact-details"
      >
        <i class="fab fa-codepen" style="color: #333;"></i> CodePen
      </a>
      <a href="mailto:msabry809@gmail.com" class="btn contact-details">
        <i class="fas fa-at"></i> Send a mail
      </a>
    </div>

    <br />
    <br />
    <p style="font-style:italic">Support! I'll be Thankful</p>
    <br />
    <link
      href="https://fonts.googleapis.com/css?family=Cookie"
      rel="stylesheet"
    />
    <a
      class="bmc-button float"
      target="_blank"
      href="https://www.buymeacoffee.com/3vEIWmo"
    >
      <img
        src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
        alt="Buy me a coffee"
      />
      <span style="margin-left:5px;font-size:28px !important;"
        >Buy me a coffee</span
      >
    </a>
  </div>
</template>

<script>
export default {
  name: "connect"
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.contact-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100vh;
  padding: 0 2rem;
  // background: $main-white;
  background-color: #ffffff;
  /* @media all and (min-width: 720px) {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cdefs%3E%3ClinearGradient id='a' x1='0' x2='0' y1='1' y2='0'%3E%3Cstop offset='0' stop-color='%230FF'/%3E%3Cstop offset='1' stop-color='%23CF6'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' x1='0' x2='0' y1='0' y2='1'%3E%3Cstop offset='0' stop-color='%233b6978'/%3E%3Cstop offset='1' stop-color='%2363b7af'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg fill='%23FFF' fill-opacity='0' stroke-miterlimit='10'%3E%3Cg stroke='url(%23a)' stroke-width='2'%3E%3Cpath transform='translate(0 0)' d='M1409 581 1450.35 511 1490 581z'/%3E%3Ccircle stroke-width='4' transform='rotate(0 800 450)' cx='500' cy='100' r='40'/%3E%3Cpath transform='translate(0 0)' d='M400.86 735.5h-83.73c0-23.12 18.74-41.87 41.87-41.87S400.86 712.38 400.86 735.5z'/%3E%3C/g%3E%3Cg stroke='url(%23b)' stroke-width='4'%3E%3Cpath transform='translate(0 0)' d='M149.8 345.2 118.4 389.8 149.8 434.4 181.2 389.8z'/%3E%3Crect stroke-width='8' transform='rotate(0 1089 759)' x='1039' y='709' width='100' height='100'/%3E%3Cpath transform='rotate(0 1400 132)' d='M1426.8 132.4 1405.7 168.8 1363.7 168.8 1342.7 132.4 1363.7 96 1405.7 96z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
  } */

  h2 {
    font-size: 6rem;
  }

  // p {
  //   font-style: italic;
  // }

  @media (max-width: 28.75em) {
    h2 {
      font-size: 4rem;
    }
  }

  .contact-links {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 980px;
    margin-top: 4rem;
    flex-wrap: wrap;

    .contact-details {
      font-size: 2.4rem;
      // text-shadow: 2px 2px 1px #1f1f1f;
      color: $first-color;
      transition: transform 0.3s ease-out;
      margin-right: 2rem;

      &:hover {
        transform: translateY(8px);
      }
    }
  }
}
.bmc-button img {
  height: 34px !important;
  width: 35px !important;
  margin-bottom: 1px !important;
  box-shadow: none !important;
  border: none !important;
  vertical-align: middle !important;
}

.bmc-button {
  padding: 7px 15px 7px 10px !important;
  line-height: 35px !important;
  height: 51px !important;
  text-decoration: none !important;
  display: inline-flex !important;
  color: #ffffff !important;
  background-color: #79d6b5 !important;
  border-radius: 5px !important;
  border: 1px solid transparent !important;
  padding: 7px 15px 7px 10px !important;
  font-size: 28px !important;
  letter-spacing: 0.6px !important;
  box-shadow: 0px 1px 2px rgba(190, 190, 190, 0.5) !important;
  -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  margin: 0 auto !important;
  font-family: "Cookie", cursive !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
}

.bmc-button:hover,
.bmc-button:active,
.bmc-button:focus {
  -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  text-decoration: none !important;
  box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  opacity: 0.85 !important;
  color: #ffffff !important;
}
</style>
